import { render, staticRenderFns } from "./CustomerForms.vue?vue&type=template&id=78c1960e&"
import script from "./CustomerForms.vue?vue&type=script&lang=js&"
export * from "./CustomerForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports